import proj4 from "proj4"
import { convertDM, convertDMSUnrounded } from "@nova/calculate-geospatial"
import { HotspotStatus, HotspotWithLabel } from "@nova/constants"

const createLine =
    (notation: string, projection?: string) =>
    ({ label, longitude, latitude }: HotspotWithLabel) => {
        if (projection) {
            ;[longitude, latitude] = proj4("WGS84", projection, [longitude, latitude])
        }
        if (notation === "decimal")
            return `"${label.replaceAll('"', '""')}", ${longitude.toFixed(6)}, ${latitude.toFixed(6)}`
        if (notation === "meters")
            return `"${label.replaceAll('"', '""')}", ${longitude.toFixed(0)}, ${latitude.toFixed(0)}`
        if (notation === "degreesMinutes") {
            const [dmy, dmx] = convertDM(longitude, latitude, 6, 6)
            return `"${label.replaceAll('"', '""')}", ${dmx}, ${dmy}`
        } else {
            // dms
            const [dmsy, dmsx] = convertDMSUnrounded(longitude, latitude)
            return `"${label.replaceAll('"', '""')}", ${dmsx}, ${dmsy}`
        }
    }

export function createHotspotsCSV(
    hotspots: HotspotWithLabel[],
    notation: string,
    projection?: string
) {
    hotspots = hotspots.sort(
        (a, b) =>
            parseInt(a.label.split("-").at(-1) || "0") - parseInt(b.label.split("-").at(-1) || "0")
    )
    return `${notation === "meters" ? "Name, Easting, Northing" : "Name, Longitude, Latitude"}
${hotspots
    .filter((e) => e.status !== HotspotStatus.Out)
    .map(createLine(notation, projection))
    .join("\n")}`
}
